import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { TODAY_BUSINESS_PATHS } from '@norum/contracts';
import { appPath, post } from './client';

const Context = createContext<string | null>(null);
export function TodayCallScope({ department, children }: { department: string; children: ReactNode }) {
  return <Context.Provider value={department}>{children}</Context.Provider>;
}
export function useTodayPost(): typeof post {
  const scopeDepartment = useContext(Context);
  return useMemo(() => async <T,>(path: Parameters<typeof post>[0], payload: Record<string, unknown> = {}): Promise<T> => {
    if (!scopeDepartment) return post<T>(path, payload);
    if (!TODAY_BUSINESS_PATHS.has(path)) throw new Error('This action is not available inside the business workspace.');
    return post<T>(appPath('/v1/today/record/call'), { scopeDepartment, path, payload });
  }, [scopeDepartment]);
}
